export enum EnewLetterStatusEnum {
  Scheduled = 'SCHEDULED',
  Delevered = 'DELIVERED',
  Failed = 'FAILED',
}
export enum ScopeEnewLetter {
  Event = 'event',
  Branch = 'branch',
  All = 'all',
  Tag = 'tag',
}
